export const calculatePoints = (study) => {
	if (study) {
		if (study.reward_points) {
			return study.reward_points;
		}
		else if (study.content && study.content.duration) {
			return Math.ceil(study.content.duration / 60);
		}
	}
	
	return 0;
};



// WEBPACK FOOTER //
// ./src/functions/rewards.js